const doc = [({"da":({"js":({"admin":({"show_boxes":({"partial":({"the_show_box_was_deleted":"Visningsboksen blev slettet.", "add_show_box":"Tilføj visningsboks"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;